import { CalendarIcon, CheckIcon, CopyIcon } from '@radix-ui/react-icons'
import { useEffect, useRef, useState } from 'react'

/**
 * Subscribe to a calendar feed so it keeps itself up to date: webcal:// for
 * Apple Calendar and Outlook (the app asks to subscribe), Google Calendar's
 * "add by URL", or the plain link to paste anywhere else.
 */
export function CalendarSubscribe({
	feedUrl,
	className,
}: {
	/** the feed's absolute https:// URL */
	feedUrl: string
	className?: string
}) {
	const webcalUrl = feedUrl.replace(/^https?:\/\//, 'webcal://')
	const googleUrl = `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(webcalUrl)}`
	const [copied, setCopied] = useState(false)
	const timer = useRef<ReturnType<typeof setTimeout>>(undefined)
	useEffect(() => () => clearTimeout(timer.current), [])

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(feedUrl)
			setCopied(true)
			clearTimeout(timer.current)
			timer.current = setTimeout(() => setCopied(false), 2500)
		} catch {
			// no clipboard (old browser, insecure origin): show it to copy by hand
			window.prompt('Kopier lenkja:', feedUrl)
		}
	}

	return (
		<div className={['cal-sub', className].filter(Boolean).join(' ')}>
			<a href={webcalUrl} className="cal-sub-btn cal-sub-primary">
				<CalendarIcon aria-hidden="true" /> Apple / Outlook
			</a>
			<a
				href={googleUrl}
				target="_blank"
				rel="noopener noreferrer"
				className="cal-sub-btn"
			>
				Google Kalender
			</a>
			<button type="button" className="cal-sub-btn" onClick={copy}>
				{copied ? (
					<>
						<CheckIcon aria-hidden="true" /> Kopiert
					</>
				) : (
					<>
						<CopyIcon aria-hidden="true" /> Kopier lenkje
					</>
				)}
			</button>
			<span className="sr-only" aria-live="polite">
				{copied ? 'Lenkja er kopiert' : ''}
			</span>
		</div>
	)
}
